import type { IpenEventsApi } from '@ipen-portal/plugin-ipen-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const ipenEventsRef = createApiRef<
  TRPCOptionsProxy<IpenEventsApi>
>().with({
  id: 'plugin.ipen.events.api',
});
